const upload_file_img_store = {
    namespaced: true,
    state: {
      file: null,
    },
    mutations: {
      setFile(state, data) {
        state.file = data;
        //console.log("The uploaded file is: " + JSON.stringify(state.file))
      },
    },
    getters: {
      currentFile(state) {
        // console.log("")
        //console.log("The uploaded file is: " + JSON.stringify(state.file))
        return state.file;
      },
    },
  };
  
  export default upload_file_img_store;
  